<template>
  <v-card data-aos="zoom-in" class="my-4 mx-1 px-8 py-5">
    <v-layout row class="px-1">
      <v-card-title class="pa-0">
        <div class="pa-0 ma-0">
          <v-card-text
            color="black"
            class="my-2 py-2"
            style="font-size: 14pt; border: 1px solid #d3d3d3; border-radius: 20px;"
          >
            <v-flex
              v-if="productByType(ticket.productType).group && !ticket.typeSelected"
            >Ticket #{{ticketIndex + 1}} {{productByType(ticket.productType).group}}</v-flex>
            <v-flex
              v-else
            >Ticket #{{ticketIndex + 1}} {{productByType(ticket.productType).productLabel}}</v-flex>
          </v-card-text>
        </div>
        <v-flex
          xs12
          sm12
          md12
          class="mt-3"
          v-if="productByType(ticket.productType).group && !ticket.typeSelected"
        >{{this.price}} €</v-flex>
        <v-flex xs12 sm12 md12 class="mt-3" v-else>{{ticket.price.toFixed(2)}} €</v-flex>
      </v-card-title>

      <v-card-text class="pa-0">Participant details</v-card-text>
      <v-row class="px-1 pt-2">
        <v-flex xs12 sm12 md3 class="px-2">
          <v-text-field
            placeholder="First Name"
            type="text"
            name="given-name"
            autocomplete="given-name"
            :value="ticket.firstName"
            @change="v => ticket.firstName = v"
            class="ticket-details-input"
            :rules="rules.firstNameRules"
          >
            <span slot="label">
              First Name
              <font color="red">*</font>
            </span>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md3 class="px-2">
          <v-text-field
            placeholder="Last Name"
            type="text"
            name="family-name"
            autocomplete="family-name"
            :value="ticket.lastName"
            @change="v => ticket.lastName = v"
            class="ticket-details-input"
            :rules="rules.lastNameRules"
          >
            <span slot="label">
              Last Name
              <font color="red">*</font>
            </span>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md3 class="px-2">
          <v-text-field
            placeholder="Position"
            type="text"
            name="organization-title"
            autocomplete="organization-title"
            :value="ticket.title"
            @change="v => ticket.title = v"
            class="ticket-details-input"
            :rules="rules.requiredRule128"
          >
            <span slot="label">
              Position
              <font color="red">*</font>
            </span>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md3 class="px-2">
          <v-text-field
            placeholder="E-mail"
            type="email"
            name="email"
            autocomplete="home email"
            :value="ticket.email"
            @change="v => ticket.email = v"
            class="ticket-details-input"
            :rules="rules.emailRules"
          >
            <span slot="label">
              E-mail
              <font color="red">*</font>
            </span>
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm12 md12 v-if="ticket.availableProducts" class="px-2">
          <v-select
            v-if="productByType(ticket.productType).group"
            :value="ticket.typeSelected ? ticket.productType : null"
            placeholder="Ticket type"
            :items="productsToOptions(ticket.availableProducts)"
            v-on:input="ticket.typeSelected = true; updateTicketType(ticket, $event);"
            item-text="label"
            :rules="rules.requiredRule"
            autocomplete="off"
            attach
          >
            <span slot="label">
              Ticket type
              <font color="red">*</font>
            </span>
          </v-select>
        </v-flex>
        <v-flex class="px-2">
          <p
            class="text-italic-grey ma-0"
            v-html="productByType(ticket.productType).productDescription"
          ></p>
        </v-flex>
      </v-row>
    </v-layout>
  </v-card>
</template>

<script>
import storeData from "../mixins/storeData";
import allRules from "../mixins/allRules";
import helperMethods from "../mixins/helperMethods";

export default {
  components: {},
  props: {
    ticket: {
      type: Object,
      required: true
    },
    ticketIndex: {
      type: Number,
      required: true
    },
    last: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {};
  },
  mixins: [storeData, allRules, helperMethods],
  methods: {
    productsToOptions(products) {
      return this._.map(products, p => ({
        label: p.productLabel,
        value: p.productType
      }));
    },
    updateTicketType(ticket, productType) {
      const product = this._.find(ticket.availableProducts, {
        productType: productType
      });
      ticket.productType = product.productType;
      ticket.price = product.price;
      ticket.vatRate = product.vatRate;
    }
  },
  computed: {
    price: function() {
      const maxPrice = this._.chain(this.ticket.availableProducts)
        .map("price")
        .max()
        .value();

      const minPrice = this._.chain(this.ticket.availableProducts)
        .map("price")
        .min()
        .value();

      if (maxPrice === minPrice) {
        return maxPrice.toFixed(2).toString();
      } else {
        return (
          minPrice.toFixed(2).toString() +
          " - " +
          maxPrice.toFixed(2).toString()
        );
      }
    }
  }
};
</script>

<style>
html:not(.no-js) [data-aos^="zoom"][data-aos^="zoom"].aos-animate {
  transform: unset !important;
}
@media (min-width: 960px) {
  #app
    > div
    > div
    > div
    > div
    > div.v-stepper__items
    > div:nth-child(2)
    > div
    > div
    > form
    > div:last-child
    > div
    > div.row
    > div.flex
    > div
    > div.v-menu__content.theme--light.menuable__content__active {
    transform: translateY(-70%);
  }
}
</style>